
import Vue from "vue";

export default Vue.extend({
  name: "AiInterviewProfileCard",
  props: {
    candidateName: {
      type: String,
      required: true
    },
    candidateRole: {
      type: String,
      required: true
    },
    avatarUri: {
      type: String,
      default: ""
    },
    resumeLabel: {
      type: String,
      default: "View my resume"
    },
    coverImage: {
      type: String,
      default: ""
    },
    resumeDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    candidateInitials(): string {
      return this.candidateName
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase() || "")
        .join("");
    }
  }
});
